import { Alert, Typography } from '@mui/material';
import { Stack } from '@mui/system';
import React from 'react';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'next-i18next';

const Wrapper = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(2, 1),
  background: theme.palette.bg.main,
  borderRadius: theme.spacing(1),
}));

interface GameWagerTableProps {
  depositBonusInfo: {
    slotsGamesPercent?: string;
    rouletteGamesPercent?: string;
    crashGamePercent?: string;
    otherGamesPercent?: string;
  };
  // Define the props for the component here
}

const GameWagerTable: React.FC<GameWagerTableProps> = ({
  depositBonusInfo,
}) => {
  // Implement the component logic here
  const [t] = useTranslation();
  if (!depositBonusInfo) {
    return null;
  }

  return (
    <Wrapper
      sx={{
        background: (theme) => theme.palette.grey[950],
        ['.MuiStack-root:not(:last-child)']: {
          borderBottom: (theme) => theme.palette.border.normal,
          paddingBottom: (theme) => theme.spacing(1),
        },
      }}
      gap={1}
    >
      <Alert
        severity="info"
        sx={{
          background: (theme) => theme.palette.bg.form,
          padding: 0.5,
          fontSize: '12px',
          color: (theme) => theme.palette.text.primary,
          '> div': {
            padding: 0,
          },
          ['> .MuiAlert-icon']: {
            fontSize: '18px',
          },
        }}
      >
        {t('rewards::Game Category Wagering Contribution %')}
      </Alert>
      <Stack display={'grid'} gridTemplateColumns={'60% 40%'}>
        <Typography>{t('rewards::Slots:')}</Typography>
        <Typography>
          {Number(depositBonusInfo.slotsGamesPercent) * 100}%
        </Typography>
      </Stack>
      <Stack display={'grid'} gridTemplateColumns={'60% 40%'}>
        <Typography>{t('rewards::Roulette and Live Roulette:')}</Typography>
        <Typography>
          {Number(depositBonusInfo.rouletteGamesPercent) * 100}%
        </Typography>
      </Stack>

      <Stack display={'grid'} gridTemplateColumns={'60% 40%'}>
        <Typography>{t('rewards::Crash and Dice Game:')}</Typography>
        <Typography>
          {Number(depositBonusInfo.crashGamePercent) * 100}%
        </Typography>
      </Stack>
      <Stack display={'grid'} gridTemplateColumns={'60% 40%'}>
        <Typography>{t('rewards::All other games:')}</Typography>
        <Typography>
          {Number(depositBonusInfo.otherGamesPercent) * 100}%
        </Typography>
      </Stack>
    </Wrapper>
  );
};

export default GameWagerTable;
